import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getCurrentUser } from 'aws-amplify/auth';
import './Footer.css';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const handleDragStart = (e: React.DragEvent) => {
    e.preventDefault();
  };

  const handleAdminLoginClick = async (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    try {
      await getCurrentUser();
      navigate('/admin/dashboard');
    } catch {
      navigate('/admin/login');
    }
  };

  return (
    <footer className="footer" data-section="footer">
      <div className="footer-logo">
        <img 
          src="/images/common/mintKitchenLogo.svg" 
          alt="Mint Kitchen Logo" 
          className="footer-logo-img" 
          draggable="false"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.style.display = 'none';
          }}
        />
      </div>
      
      <div className="footer-content">
        <div className="footer-section">
          <h4>Leistungen</h4>
          <ul>
            <li><Link to="/ki-werkstatt" onDragStart={handleDragStart}>KI-Werkstatt</Link></li>
            <li><Link to="/ki-kurse" onDragStart={handleDragStart}>KI-Kurse</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Rechtliches</h4>
          <ul>
            <li><Link to="/impressum" onDragStart={handleDragStart}>Impressum</Link></li>
            <li><Link to="/datenschutz" onDragStart={handleDragStart}>Datenschutz</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Media</h4>
          <ul>
            <li>
              <a 
                href="https://www.linkedin.com/company/80532564" 
                target="_blank" 
                rel="noopener noreferrer"
                onDragStart={handleDragStart}
              >
                LinkedIn
              </a>
            </li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Kontakt</h4>
          <ul>
            <li><Link to="/kontakt" onDragStart={handleDragStart}>Kontaktformular</Link></li>
          </ul>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2026 MINTkitchen KG. Alle Rechte vorbehalten.</p>
      </div>
    </footer>
  );
};

export default Footer;